module.exports = {"projectName":"LINKs","copyright":"Copyright © HIBIYA-KADAN All Rights Reserved.","apiURL":"https://links-api.hibiyakadan-wedding.com/mgmt","materialsAndEquipmentAdjustmentListURL":"https://staff-links.hibiyakadan-wedding.com/adjustment/materials_and_equipment_list","deliveryEvaluationURL":"https://partner-links.hibiyakadan-wedding.com/delivery_evaluation"}


//////////////////
// WEBPACK FOOTER
// ./src/config/config.json
// module id = QkNq
// module chunks = 1